import type { ApiConfig } from '../schemas/api';
import type { McpConfig } from '../schemas/mcp';
import type { MonitoringConfig } from '../schemas/monitoring';

// Extract dynamic monitoring values
// biome-ignore lint/complexity/useLiteralKeys: Required for TypeScript index signature
const viteLogLevel = import.meta.env['VITE_LOG_LEVEL'];
// biome-ignore lint/complexity/useLiteralKeys: Required for TypeScript index signature
const viteSampleRate = import.meta.env['VITE_SAMPLE_RATE'];

const sampleRate = viteSampleRate ? parseFloat(viteSampleRate) : 0.1;
const logLevel = (viteLogLevel as 'error' | 'warn' | 'info' | 'debug') || 'error';

export const productionConfig = {
  mcp: {
    // biome-ignore lint/complexity/useLiteralKeys: Required for TypeScript index signature
    baseURL: import.meta.env['VITE_MCP_BASE_URL'] || 'https://mcp.compounds.dev',
  } satisfies McpConfig,

  api: {
    // biome-ignore lint/complexity/useLiteralKeys: Required for TypeScript index signature
    baseURL: import.meta.env['VITE_API_BASE_URL'] || 'https://api.compounds.dev',
    timeout: 60000,
    retryAttempts: 3,
    retryDelay: 2000,
    retryableStatuses: [408, 429, 500, 502, 503, 504],
    retryableNetworkErrors: ['Failed to fetch', 'Network request failed'],
    endpoints: {
      projects: '/projects',
      tasks: '/tasks',
      subtasks: '/subtasks',
    },
  } satisfies ApiConfig,

  monitoring: {
    // biome-ignore lint/complexity/useLiteralKeys: Required for TypeScript index signature
    dsn: import.meta.env['VITE_SENTRY_DSN'],
    // biome-ignore lint/complexity/useLiteralKeys: Required for TypeScript index signature
    environment: import.meta.env['VITE_SENTRY_ENVIRONMENT'] || 'production',
    enableTracing: true,
    sampleRate,
    debug: false,
    logLevel,
    tracingOrigins: ['compounds.dev', 'localhost', '127.0.0.1'],
    enableSessionReplay: false,
    replaysSessionSampleRate: 0, // Disabled in prod
    replaysOnErrorSampleRate: 0, // Disabled in prod
  } satisfies MonitoringConfig,
} as const;
